const debugMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const debugMode: string = urlParams.get("debug")!;
  return process.env.NODE_ENV === "development" || debugMode === "true";
};

export const debug = (...args: any[]): void => {
  if (debugMode()) {
    // console.log(...args);
  }
};

// Turtles all the way dooooowwwwnnnnn...
debug.log = debug;

debug.warn = (...args: any[]): void => {
  if (debugMode()) {
    console.warn(...args);
  }
};

debug.error = (...args: any[]): void => {
  if (debugMode()) {
    console.error(...args);
  }
};

export default debug;
